"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.TEXT_SIZE_CLASSNAMES_BY_LEVEL = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Typography_1 = require("../Typography/Typography");
// TODO move me
exports.TEXT_SIZE_CLASSNAMES_BY_LEVEL = [
    'h100',
    'h200',
    'h300',
    'h400',
    'h500',
    'h600',
    'h700'
];
function Header({ children, title, level = 5, borderless = false, className }) {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, classnames_1.default)('flex', 'items-center', 'bg-white', {
            'border-b border-b-silver-30': !borderless
        }, className) }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, Object.assign({ as: "h1", variant: exports.TEXT_SIZE_CLASSNAMES_BY_LEVEL[level], className: "hidden pr-8 sm:block" }, { children: title })), children] })));
}
exports.Header = Header;
//# sourceMappingURL=Header.js.map